import { OrderStatus, PaymentOrder } from "@/types";

import { axios } from "../axios.instance";

export type GetPaymentsRequest = {
  perPage?: number;
  page?: number;
  status?: OrderStatus;
};

export type GetPaymentsResponse = {
  data: PaymentOrder[];
  meta: {
    hasNextPage: boolean;
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
  };
};

export const getPayments = async (params: GetPaymentsRequest): Promise<GetPaymentsResponse> => {
  const { data } = await axios.get(`/payments/orders`, {
    params,
  });

  return data;
};
